<template>
    <div
        class="modal-card"
        :class="{ 'has-header': props.hasHeader }"
    >
        <HeaderWrapper v-if="props.hasHeader">
            <h3 v-if="props.title">
                {{ props.title }}
            </h3>
            <slot
                v-else
                name="header"
            />
            <UiIcon
                v-if="props.hasClose"
                class="close"
                icon="close"
                color="white"
                :size="32"
                @click="emit('close')"
            />
        </HeaderWrapper>
        <UiIcon
            v-else-if="props.hasClose"
            class="close no-header"
            icon="mini-x-mark"
            color=""
            :size="32"
            @click="emit('close')"
        />
        <div class="box p-0">
            <div class="p-5">
                <slot />
            </div>
            <div
                v-if="$slots.footer"
                class="bg-gray-100 items-center py-2 border-t border-gray-300"
            >
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import HeaderWrapper from '@/components/Global/Header/HeaderWrapper/HeaderWrapper.vue';

    const props = withDefaults(
        defineProps<{
            title?: string;
            hasClose?: boolean;
            hasHeader?: boolean;
        }>(),
        {
            title: '',
            hasClose: true,
            hasHeader: true,
        },
    );

    const emit = defineEmits<{
        close: [];
    }>();
</script>

<style lang="scss" scoped>
    @use '@/assets/scss/imports';

    .modal-card {
        position: relative;
    }

    :deep(.modal-close.is-large) {
        display: none;
    }

    :deep(.header-wrapper) {
        height: 80px;
    }

    .header-wrapper {
        border-top-left-radius: imports.$border-radius;
        border-top-right-radius: imports.$border-radius;
        display: flex;
        justify-content: space-between;
    }

    .box {
        .has-header & {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }

        overflow: auto;
    }

    .close {
        cursor: pointer;

        &:hover {
            opacity: 0.8;
        }

        &.no-header {
            position: absolute;
            right: 16px;
            top: 16px;
        }
    }
</style>
